import { showBootstrapModal, hideBootstrapModal } from 'ws-app'
import { gUnits, showLengthWithUnits, showBigLinearForce, showBigPointLoad, showBigMoment,
  bigLinearForceUnit, wsParseLength, bigPointLoadUnit, bigMomentUnit
 } from 'ws-units'

 import { validateRequiredInput, validateLengthInput, validateLocation } from 'ws-validation'


function plusSymbol() {
  return String.raw`
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
  </svg>`
}

class LoadDialogComponent extends HTMLElement {

  showAllLoadCases = true

  pointLoads = []
  distLoads = []

  loadCaseInputIdsMap = {
    'd-load-input-0': 'D',
    'd-load-input': 'D',
    'l-load-input': 'L',
    'lr-load-input': 'Lr',
    's-load-input': 'S',
    'w-load-input': 'W',
    'e-load-input': 'E',
    'h-load-input': 'H',
    'r-load-input': 'R'
  }

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.onUpdate(event.detail), true)
    document.addEventListener('loads-changed', (event) => this.onUpdate(event.detail), true)
    document.addEventListener('spans-did-change', (event) => this.onUpdate(event.detail), true)
    
    document.addEventListener('open-point-load-dialog', (event) => this.openPointLoadDialog(event.detail), true)
    document.addEventListener('open-moment-dialog', (event) => this.openMomentLoadDialog(event.detail), true)
    document.addEventListener('open-uniform-load-dialog', (event) => this.openUniformLoadDialog(event.detail), true)
    document.addEventListener('open-linear-load-dialog', (event) => this.openLinearLoadDialog(event.detail), true)

    document.addEventListener('open-modal-load-dialog', () => {
      showBootstrapModal('modal-load-dialog')
    }, true)

    document.addEventListener('open-modal-load-editor-dialog', () => {
      showBootstrapModal('modal-load-editor-dialog')
    }, true)
  }

  onUpdate(project) {

    this.pointLoads = project.beam.pointLoads
    this.distLoads = project.beam.distLoads
    this.beamLength = project.beam.TotalLength()


    if (parseInt(project.loadPrecision) === 2) {
      document.getElementById("load-precision-dropdown").innerHTML = "Load Precision: 2 decimal places"
    } else {
      document.getElementById("load-precision-dropdown").innerHTML = "Load Precision: 3 decimal places"
    }

    document.getElementById('self-weight-checkbox').checked = project.design.includeSelfWeight

    this.updateLoadTable(project)
  }


  updateLoadTable(project) {
    //let showAllLoadCases = document.getElementById('show-all-load-cases-1').checked;
    let cardStr = `
      <div style="max-height: 55vh; overflow-y: auto; padding-right: 4px;">
        <div class="row">
    `;
    let loadCount = 0;

    function makeCaseBadges(load, isLinear, isMoment) {
      const keys = ['D', 'L', 'Lr', 'S', 'W', 'E', 'H', 'R'];
      let badges = '';
      // Use your requested background color
      const badgeBg = "#337ab7";
      const badgeColor = "#fff";
      keys.forEach(key => {
        let v1 = parseFloat(load[key]);
        let v2 = isLinear ? parseFloat(load[`${key}2`]) : undefined;
        let showBadge = false;
        let badgeText = '';

        if (isLinear) {
          if (v1 !== 0 && v2 !== 0) {
            showBadge = true;
            badgeText = `${key}: ${showBigLinearForce(v1, false)} &rarr; ${showBigLinearForce(v2, false)}`;
          } else if (v1 !== 0) {
            showBadge = true;
            badgeText = `${key}: ${showBigLinearForce(v1, false)}`;
          } else if (v2 !== 0) {
            showBadge = true;
            badgeText = `${key}: ${showBigLinearForce(v2, false)}`;
          }
        } else if (isMoment) {
          if (v1 !== 0) {
            showBadge = true;
            badgeText = `${key}: ${showBigMoment(v1, false)}`;
          }
        } else if (load.isPoint || load.isMoment === false) {
          if (v1 !== 0) {
            showBadge = true;
            badgeText = `${key}: ${showBigPointLoad(v1, false)}`;
          }
        } else {
          if (v1 !== 0) {
            showBadge = true;
            badgeText = `${key}: ${showBigLinearForce(v1, false)}`;
          }
        }

        if (showBadge) {
          badges += `<span class="badge px-2 py-1 me-2" style="background-color:${badgeBg};color:${badgeColor};font-weight:400;border:1px solid #245076;">${badgeText}</span>`;
        }
      });
      return badges;
    }

    // Helper for magnitude display
    function makeMagnitude(load, isLinear, isMoment) {
      if (isMoment) return showBigMoment(load['D'], true);
      if (isLinear) {
        return `
          <div>
            <span class="fw-semibold">Start:</span> ${showBigLinearForce(load['D'], false)}
          </div>
          <div>
            <span class="fw-semibold">End:</span> ${showBigLinearForce(load['D2'], false)}
          </div>
        `;
      }
      return showBigLinearForce(load['D'], true);
    }

    // Distributed Loads
    for (let i = 0; i < project.beam.distLoads.length; i++) {
      const load = project.beam.distLoads[i];
      const isLinear = load.isLinear;
      cardStr += `
        <div class="col-12 mb-2">
          <div class="card shadow-sm" style="cursor:pointer;" onclick="document.querySelector('load-dialog-component').open${isLinear ? 'Linear' : 'Uniform'}LoadDialog(${i})">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class=""><span class="badge fs-6 bg-secondary">${isLinear ? 'Linear' : 'Uniform'}</span></div>
                <div>${makeCaseBadges(load, isLinear, false)}</div>
              </div>
              <div class="mb-1"><strong>Location:</strong> ${showLengthWithUnits(load.x1)} &rarr; ${showLengthWithUnits(load.x2)}</div>
            </div>
          </div>
        </div>
      `;
      loadCount += 1;
    }

    // Point/Moment Loads
    for (let i = 0; i < project.beam.pointLoads.length; i++) {
      const load = project.beam.pointLoads[i];
      const isMoment = load.isMoment === true;
      cardStr += `
        <div class="col-12 mb-2">
          <div class="card shadow-sm" style="cursor:pointer;" onclick="document.querySelector('load-dialog-component').open${isMoment ? 'Moment' : 'Point'}LoadDialog(${i})">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class=""><span class="badge fs-6 bg-secondary">${isMoment ? 'Moment' : 'Point'}</span></div>
                <div>${makeCaseBadges(load, false, isMoment)}</div>
              </div>
              <div class="mb-1"><strong>Location:</strong> ${showLengthWithUnits(load.x)}</div>
            </div>
          </div>
        </div>
      `;
      loadCount += 1;
    }
    cardStr += `</div></div`;

    document.getElementById('all-loads-table').innerHTML = cardStr;

    // Hide or show "Beam Load" label based on load count
    const selectLabel = document.querySelector('.h6.py-3');
    if (selectLabel) {
      selectLabel.style.display = loadCount === 0 ? 'none' : '';
    }
  }

  configureForDistributedLoad(index) {
    let str = String.raw`
    <table>
      <tr>
        <td>Starting @</td>
        <td style="padding:10px;">
          <input style='width:100px;' id='starting-at-input' type='text' value='0' />
        </td>
        <td style="padding:10px;">
          <button type="button" class="btn btn-sm btn-primary button-shadow" id='left-end-load-button'>Left End</button>
        </td>
      </tr>
      <tr>
        <td>Ending @</td>
        <td style="padding:10px;">
          <input style='width:100px;' id='ending-at-input' type='text' name='ending-at-input' value='0' />
        </td>
        <td style="padding:10px;">
          <button type="button" class="btn btn-sm btn-primary button-shadow" id='right-end-load-button'>Right End</button>
        </td>
      </tr>
    </table>
    `

    document.getElementById('load-location-form').innerHTML = str

    if (typeof index !== "undefined" && this.distLoads[index]) {
      const load = this.distLoads[index]
      document.getElementById('starting-at-input').value = showLengthWithUnits(load.x1)
      document.getElementById('ending-at-input').value = showLengthWithUnits(load.x2)
      // update load input values
      for (const [elementId, loadCaseName] of Object.entries(this.loadCaseInputIdsMap)) {
        document.getElementById(elementId).value = showBigLinearForce(load[loadCaseName], false)
        if (load.isLinear) {
          document.getElementById(`${elementId}-2`).value = showBigLinearForce(load[`${loadCaseName}2`], false)
        }
      }
    } else {
      document.getElementById('starting-at-input').value = showLengthWithUnits(0)
      document.getElementById('ending-at-input').value = showLengthWithUnits(this.beamLength)
    }

    document.getElementById('starting-at-input').onchange = () => { this.validateDistributedLoadLocations() }
    document.getElementById('ending-at-input').onchange = () => { this.validateDistributedLoadLocations() }

    document.getElementById('left-end-load-button').onclick = () => { this.onLeftEndClick('starting-at-input') }
    document.getElementById('right-end-load-button').onclick = () => { this.onRightEndClick('ending-at-input') }

    if (document.getElementById('show-all-load-cases-1').checked === false) {
      document.getElementById('simple-load-magnitude-table').classList.remove('d-none')
      document.getElementById('full-load-magnitude-table').classList.add('d-none')
    } else {
      document.getElementById('simple-load-magnitude-table').classList.add('d-none')
      document.getElementById('full-load-magnitude-table').classList.remove('d-none')
    }

    for (const [key, value] of Object.entries(this.loadCaseInputIdsMap)) {
      document.getElementById(key).onchange = () => this.onDistributedLoadValueChange(key)
    }

    // update input table heading units
    const unitLabels = document.getElementsByClassName('load-units-label')
    for (let i = 0; i < unitLabels.length; i++) {
      unitLabels[i].innerHTML = bigLinearForceUnit()
    }
  }

  configureForPointLoad(index) {
    let str = String.raw`
    <table id="point-load-location-table">
      <tr>
        <td><span id="point-load-label">Point</span> Load @</td>
        <td style="padding:10px;">
          <input style='width:100px;' id='starting-at-input' type='text' value='0' />
        </td>
        <td style="padding:10px;">
          <button type="button" class="btn btn-sm btn-primary button-shadow" id='left-end-load-button'>Left End</button>
        </td>
        <td style="padding:10px;">
          <button type="button" class="btn btn-sm btn-primary button-shadow" id='right-end-load-button'>Right End</button>
        </td>
      </tr>
    </table>   
    `

    document.getElementById('load-location-form').innerHTML = str

    if (index !== undefined && this.pointLoads[index]) {
      const load = this.pointLoads[index]
      
      document.getElementById('starting-at-input').value = showLengthWithUnits(load.x)
      // update load input values
      for (const [key, value] of Object.entries(this.loadCaseInputIdsMap)) {
        document.getElementById(key).value = load.isMoment ? showBigMoment(load[value], false) : showBigPointLoad(load[value], false)
        document.getElementById(key).onchange = () => this.validatePointLoadLocations()
      }
    } else {
      document.getElementById('starting-at-input').value = showLengthWithUnits(0)
    }

    document.getElementById('starting-at-input').onchange = () => { this.validatePointLoadLocations() }

    document.getElementById('left-end-load-button').onclick = () => { this.onLeftEndClick('starting-at-input') }
    document.getElementById('right-end-load-button').onclick = () => { this.onRightEndClick('starting-at-input') }

    if (document.getElementById('show-all-load-cases-1').checked === false) {
      document.getElementById('simple-load-magnitude-table').classList.remove('d-none')
      document.getElementById('full-load-magnitude-table').classList.add('d-none')
    } else {
      document.getElementById('simple-load-magnitude-table').classList.add('d-none')
      document.getElementById('full-load-magnitude-table').classList.remove('d-none')
    }

    for (const [key, value] of Object.entries(this.loadCaseInputIdsMap)) {
      document.getElementById(key).onchange = () => this.onPointLoadValueChange(key)
    }

  }

  setLoadDialog({
    label,
    showEndMagnitude,
    showDelete,
    saveHandler,
    deleteHandler,
    configureHandler,
    unitLabel
  }) {
    document.getElementById('modal-load-editor-label').innerHTML = label;

    // Show/hide End Magnitude column and _2 inputs
    const endCol = document.getElementById('col-end-magnitude-label');
    if (endCol) {
      endCol.classList.toggle('d-none', !showEndMagnitude);
    }
    const keys = ['d', 'l', 'lr', 's', 'w', 'e', 'h', 'r'];
    keys.forEach(key => {
      const col = document.getElementById(`col-${key}-load-input-2`);
      if (col) col.classList.toggle('d-none', !showEndMagnitude);
    });

    // Show/hide End Magnitude row in simple table
    const endRow = document.getElementById('distributed-load-magnitude-2');
    if (endRow) endRow.classList.toggle('d-none', !showEndMagnitude);

    // Show/hide delete button
    const deleteBtn = document.getElementById('delete-load-button');
    if (deleteBtn) {
      deleteBtn.classList.toggle('d-none', !showDelete);
      deleteBtn.onclick = deleteHandler;
    }

    // Save handler
    document.getElementById('save-load-button').onclick = saveHandler;

    // Configure form fields
    if (configureHandler) configureHandler();

    // Update unit labels
    const unitLabels = document.getElementsByClassName('load-units-label');
    for (let i = 0; i < unitLabels.length; i++) {
      unitLabels[i].innerHTML = unitLabel;
    }

    hideBootstrapModal('modal-load-dialog');
    showBootstrapModal('modal-load-editor-dialog');
  }

  // Usage in your onAdd* and open* methods:

  onAddPointLoadClick() {
    this.setLoadDialog({
      label: 'Add Point Load',
      showEndMagnitude: false,
      showDelete: false,
      saveHandler: () => this.onSavePointLoadClick(undefined, false),
      deleteHandler: null,
      configureHandler: () => this.configureForPointLoad(),
      unitLabel: bigPointLoadUnit()
    });
  }

  openPointLoadDialog(index) {
    this.setLoadDialog({
      label: 'Edit Point Load',
      showEndMagnitude: false,
      showDelete: true,
      saveHandler: () => this.onSavePointLoadClick(index, false),
      deleteHandler: () => this.onDeletePointLoadClick(index),
      configureHandler: () => this.configureForPointLoad(index),
      unitLabel: bigPointLoadUnit()
    });
  }

  onAddMomentLoadClick() {
    this.setLoadDialog({
      label: 'Add Moment Load',
      showEndMagnitude: false,
      showDelete: false,
      saveHandler: () => this.onSavePointLoadClick(undefined, true),
      deleteHandler: null,
      configureHandler: () => this.configureForPointLoad(),
      unitLabel: bigMomentUnit()
    });
  }

  openMomentLoadDialog(index) {
    this.setLoadDialog({
      label: 'Edit Moment Load',
      showEndMagnitude: false,
      showDelete: true,
      saveHandler: () => this.onSavePointLoadClick(index, true),
      deleteHandler: () => this.onDeletePointLoadClick(index),
      configureHandler: () => this.configureForPointLoad(index),
      unitLabel: bigMomentUnit()
    });
  }

  onAddUniformLoadClick() {
    this.setLoadDialog({
      label: 'Add Uniform Load',
      showEndMagnitude: false,
      showDelete: false,
      saveHandler: () => this.onSaveDistributedLoadClick(undefined, false),
      deleteHandler: null,
      configureHandler: () => this.configureForDistributedLoad(),
      unitLabel: bigLinearForceUnit()
    });
  }

  openUniformLoadDialog(index) {
    this.setLoadDialog({
      label: 'Edit Uniform Load',
      showEndMagnitude: false,
      showDelete: true,
      saveHandler: () => this.onSaveDistributedLoadClick(index, false),
      deleteHandler: () => this.onDeleteDistributedLoadClick(index),
      configureHandler: () => this.configureForDistributedLoad(index),
      unitLabel: bigLinearForceUnit()
    });
  }

  onAddLinearLoadClick() {
    this.setLoadDialog({
      label: 'Add Linear Load',
      showEndMagnitude: true,
      showDelete: false,
      saveHandler: () => this.onSaveDistributedLoadClick(undefined, true),
      deleteHandler: null,
      configureHandler: () => this.configureForDistributedLoad(),
      unitLabel: bigLinearForceUnit()
    });
  }

  openLinearLoadDialog(index) {
    this.setLoadDialog({
      label: 'Edit Linear Load',
      showEndMagnitude: true,
      showDelete: true,
      saveHandler: () => this.onSaveDistributedLoadClick(index, true),
      deleteHandler: () => this.onDeleteDistributedLoadClick(index),
      configureHandler: () => this.configureForDistributedLoad(index),
      unitLabel: bigLinearForceUnit()
    });
  }

  onSelfWeightClick() {
    const includeSelfWeight = document.getElementById('self-weight-checkbox').checked
    document.dispatchEvent(new CustomEvent('include-self-weight-changed', { detail: includeSelfWeight }))
  }

  onShowAllLoadCases1Click() {
    const showAllLoadCases = document.getElementById('show-all-load-cases-1').checked === true
    document.getElementById('show-all-load-cases-2').checked = showAllLoadCases
    this.onShowAllLoadCasesClick(showAllLoadCases)
  }

  onShowAllLoadCases2Click() {
    const showAllLoadCases = document.getElementById('show-all-load-cases-2').checked === true
    document.getElementById('show-all-load-cases-1').checked = showAllLoadCases
    this.onShowAllLoadCasesClick(showAllLoadCases)
  }

  onShowAllLoadCasesClick(showAllLoadCases) {
    var oneLoadCaseElements = document.querySelectorAll('.one-load-case')
    var allLoadCasesElements = document.querySelectorAll('.all-load-cases')

    oneLoadCaseElements.forEach(element => {
      showAllLoadCases ? element.classList.add('d-none') : element.classList.remove('d-none')
    })

    allLoadCasesElements.forEach(element => {
      showAllLoadCases ? element.classList.remove('d-none') : element.classList.add('d-none')
    })

    if (showAllLoadCases) {
      document.getElementById('simple-load-magnitude-table').classList.add('d-none')
      document.getElementById('full-load-magnitude-table').classList.remove('d-none')
    } else {
      document.getElementById('simple-load-magnitude-table').classList.remove('d-none')
      document.getElementById('full-load-magnitude-table').classList.add('d-none')
    }

  }

  validateDistributedLoadLocations() {
    let id1 = 'starting-at-input'
    let id2 = 'ending-at-input'
    return (validateRequiredInput(id1) &&
      validateLengthInput(id1) &&
      validateLocation(id1, this.beamLength) &&
      validateRequiredInput(id2) &&
      validateLengthInput(id2) &&
      validateLocation(id2, this.beamLength))
  }

  validatePointLoadLocations() {
    let id1 = 'starting-at-input'
    return (validateRequiredInput(id1) &&
      validateLengthInput(id1) &&
      validateLocation(id1, this.beamLength))
  }

  onLoadPrecisionClick() {
    const loadPrecision = document.getElementById('load-precision-2').checked ? 2 : 3
    document.dispatchEvent(new CustomEvent('load-precision-changed', { detail: loadPrecision }))
  }

  onLeftEndClick(id) {
    document.getElementById(id).value = showLengthWithUnits(0)
  }

  onRightEndClick(id) {
    document.getElementById(id).value = showLengthWithUnits(this.beamLength)
  }

  onPointLoadValueChange(id) {
    return validateRequiredInput(id)
  }

  onDistributedLoadValueChange(id) {
    return validateRequiredInput(id)
  }

  getLoadValues(factor, isLinear) {
    let values = {}
    for (const [elementId, loadCaseName] of Object.entries(this.loadCaseInputIdsMap)) {
      values[loadCaseName] = parseFloat(document.getElementById(elementId).value) * factor
      if (isLinear) {
        values[`${loadCaseName}2`] = parseFloat(document.getElementById(`${elementId}-2`).value) * factor
      }
    }
    let showAllLoadCases = document.getElementById('show-all-load-cases-2').checked
    if (!showAllLoadCases) {
      values['D'] = parseFloat(document.getElementById('d-load-input-0').value) * factor
      if (isLinear) {
        values['D2'] = parseFloat(document.getElementById('d-load-input-0-2').value) * factor
      }
    }
    return values
  }

  onSavePointLoadClick(index, isMoment) {
    if(this.validatePointLoadLocations() === false) {
      return
    }
    
    // values can be:
    // 1. kips: if kips convert to lbs
    // 2. kips-ft: if kips-ft convert to lb-inches
    // 3. kilonewtons: if killonewtons convert to lbs
    // 4. kilonewton-meters: if killonewton-meters convert to lb-inches
    const kipsToLbs = 1000 // english point load (kips to lbs)
    const kipsFtToLbInches = 1000 * 12 // english moment (kips-ft to lb-inches)
    const kiloNewtonsToLbs = 1000 * 0.224809 // metric point load (kN to lbs)
    const kiloNewtonMetersToLbInches = 1000 * 0.224809 * 39.3701 // metric moment (kN-m to lb-in)

    const pointLoadConversion = {
      'english-lbs': 1.0, // lbs -> lbs
      'english': kipsToLbs,
      'metric': kiloNewtonsToLbs
    }
    const momentConversion = {
      'english-lbs': 12, // lb-ft -> lb-in
      'english': kipsFtToLbInches, 
      'metric': kiloNewtonMetersToLbInches
    }

    const factor = isMoment ? momentConversion[gUnits] : pointLoadConversion[gUnits]
    
    // values could be in english or metric units here
    const values = this.getLoadValues(factor, false) 
    
    // length could be in english or metric units here
    const x = wsParseLength(document.getElementById('starting-at-input').value)

    const dict = Object.assign({}, { 'index': index, 'x': x, 'isMoment': isMoment }, values)
    hideBootstrapModal('modal-load-editor-dialog')
    document.dispatchEvent(new CustomEvent('save-point-load', { detail: dict }))
  }

  onSaveDistributedLoadClick(index, isLinear) {
    if(this.validateDistributedLoadLocations() === false) {
      return
    }


    // values can be:
    // 1. lbs / ft: if lbs / ft convert to lbs / inches 
    // 1. kips / ft: if kips convert to lbs / inches
    // 2. kN / meter: if kN / meter lbs / inches
    const lbsPerFtToLbsPerInches = 1.0 / 12 
    const kipsPerFeetToLbsPerInches = 1000 / 12  
    const kNPerMeterToLbsPerInches = 1000 * 0.224809 / 39.3701 

    const momentConversion = {
      'english-lbs': lbsPerFtToLbsPerInches, // lbs -> lbs
      'english': kipsPerFeetToLbsPerInches,
      'metric': kNPerMeterToLbsPerInches
    }
    
    const factor = momentConversion[gUnits]

    const values = this.getLoadValues(factor, isLinear)
    const x1 = wsParseLength(document.getElementById('starting-at-input').value)
    const x2 = wsParseLength(document.getElementById('ending-at-input').value)
    const dict = Object.assign({}, { 'index': index, 'x1': x1, 'x2': x2, 'isLinear': isLinear }, values)
    hideBootstrapModal('modal-load-editor-dialog')
    document.dispatchEvent(new CustomEvent('save-distributed-load', { detail: dict }))
  }

  onDeletePointLoadClick(index) {
    hideBootstrapModal('modal-load-editor-dialog')
    document.dispatchEvent(new CustomEvent('delete-point-load', { detail: index }))
  }

  onDeleteDistributedLoadClick(index) {
    hideBootstrapModal('modal-load-editor-dialog')
    document.dispatchEvent(new CustomEvent('delete-distributed-load', { detail: index }))
  }

  connectedCallback() {

    this.innerHTML = String.raw`

    <div class="modal fade" id="modal-load-dialog" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

        <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5" id="modal-load-dialog-label">Loads</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          
          <div class="modal-body modal-body-shadow text-center">
            <!--<h3 class="panel-title mb-4">New Loads</h3>-->
            <!--<br>-->
            <button id="add-uniform-load-button" type="button" class="btn btn-primary button-shadow">
              ${plusSymbol()} Add Uniform
            </button>
            <button id="add-linear-load-button" type="button" class="btn btn-primary button-shadow">
              ${plusSymbol()} Add Linear
            </button>
            <button id="add-point-load-button" type="button" class="btn btn-primary button-shadow">
              ${plusSymbol()} Add Point
            </button>
            <button id="add-moment-load-button" type="button" class="btn btn-primary button-shadow">
              ${plusSymbol()} Add Moment
            </button>
          </div>
  
          <div class="modal-body">

          <div class="fs-5 my-2">Load Settings</div>
            
          <div class="dropdown">
              <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" id="load-precision-dropdown">
                Load Precision: 2 decimal places
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" id="load-precision-two-decimals">
                    Load Precision: 2 decimal places
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" id="load-precision-three-decimals">
                    Load Precision: 3 decimal places
                  </a>
                </li>
              </ul>

              <i class="fa fa-question-circle text-blue" data-bs-toggle="tooltip" data-bs-placement="right" 
                title="Change this value to 3 for lighter loads (loads less than 1000 lbs).">
              </i>
            </div>
          
            <div class="card-body">
                
              <div class="py-2">
                <label>
                  <input id="self-weight-checkbox" type='checkbox' value=''>
                  Include Self-Weight as Dead Load
                </label>  
              </div>

              <div class=" py-2">
                <label>
                  <input id="show-all-load-cases-1" type='checkbox' value='' checked>
                  Show All Load Cases (Design Mode)
                </label>  
                <i class="glyphicon glyphicon-question-sign text-success" rel="tooltip"
                  title="Check this box to add loads to load cases other than the Dead Load case (e.g. Live, Snow, Wind, etc.)"
                  id="show-all-load-cases-tooltip-1"></i>
              </div>

              <div class="h6 py-3 ">Beam Loads (select a load to edit)</div>   

              <div id="all-loads-table"></div>
              
            </div>  
          </div>
          
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        
        </div>
      </div>
    </div>


    <!-- Modal Load Editor Dialog -->
    <div class="modal fade" id="modal-load-editor-dialog" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-default">
            <h4 class="modal-title fs-5" id="modal-load-editor-label">Create a Load</span></h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            
            <div class="card-body">
              
              <div class="h6 pt-3">Location</div>
              
              <div class="py-2">
                <form id="load-location-form"></form>
              </div>

              <div class="h6 pt-3">Magnitude</div>
              
              <div class="py-2">
                <label>
                  <input id="show-all-load-cases-2" type='checkbox' value='' checked>
                  Show All Load Cases (Design Mode)
                </label>  
              </div>

              <div id="simple-load-magnitude-table">
                <form>
                  <div class="mb-3 row align-items-center">
                    <label for="d-load-input-0" class="col-sm-4 col-form-label">With Magnitude (<span class="load-units-label">kips</span>)</label>
                    <div class="col-sm-8">
                      <input type="number" class="form-control" id="d-load-input-0" value="1.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center" id="distributed-load-magnitude-2">
                    <label for="d-load-input-0-2" class="col-sm-4 col-form-label">End Magnitude (<span class="load-units-label">kips</span>)</label>
                    <div class="col-sm-8">
                      <input type="number" class="form-control" id="d-load-input-0-2" value="0.00" />
                    </div>
                  </div>
                </form>
              </div>
                  
              <div id="full-load-magnitude-table">
                <form>
                  <div class="mb-3 row align-items-center">
                    <label class="col-sm-3 col-form-label"></label>
                    <div class="col-sm-4 fw-bold">Start Magnitude (<span class="load-units-label">kips</span>)</div>
                    <div class="col-sm-4 fw-bold d-none" id="col-end-magnitude-label">End Magnitude (<span class="load-units-label">kips</span>)</div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="d-load-input" class="col-sm-3 col-form-label">Dead Load (D)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="d-load-input" value="1.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-d-load-input-2">
                      <input type="number" class="form-control" id="d-load-input-2" value="2.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="l-load-input" class="col-sm-3 col-form-label">Live Load (L)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="l-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-l-load-input-2">
                      <input type="number" class="form-control" id="l-load-input-2" value="0.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="lr-load-input" class="col-sm-3 col-form-label">Live Roof (Lr)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="lr-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-lr-load-input-2">
                      <input type="number" class="form-control" id="lr-load-input-2" value="0.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="s-load-input" class="col-sm-3 col-form-label">Snow (S)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="s-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-s-load-input-2">
                      <input type="number" class="form-control" id="s-load-input-2" value="0.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="w-load-input" class="col-sm-3 col-form-label">Wind (W)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="w-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-w-load-input-2">
                      <input type="number" class="form-control" id="w-load-input-2" value="0.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="e-load-input" class="col-sm-3 col-form-label">Earth (E)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="e-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-e-load-input-2">
                      <input type="number" class="form-control" id="e-load-input-2" value="0.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="h-load-input" class="col-sm-3 col-form-label">Lateral Pressure (H)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="h-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-h-load-input-2">
                      <input type="number" class="form-control" id="h-load-input-2" value="0.00" />
                    </div>
                  </div>
                  <div class="mb-3 row align-items-center">
                    <label for="r-load-input" class="col-sm-3 col-form-label">Roof (R)</label>
                    <div class="col-sm-4">
                      <input type="number" class="form-control" id="r-load-input" value="0.00" />
                    </div>
                    <div class="col-sm-4 d-none" id="col-r-load-input-2">
                      <input type="number" class="form-control" id="r-load-input-2" value="0.00" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          
          <div class="modal-footer justify-content-between">
            <div>
              <button type="button" class="btn btn-danger pull-left" id="delete-load-button">Delete Load</button>
            </div>
            <div>
              <button type="button" class="btn btn-primary" id="save-load-button">Save</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    `

    document.getElementById('add-uniform-load-button').onclick = () => { this.onAddUniformLoadClick() }
    document.getElementById('add-linear-load-button').onclick = () => { this.onAddLinearLoadClick() }
    document.getElementById('add-point-load-button').onclick = () => { this.onAddPointLoadClick() }
    document.getElementById('add-moment-load-button').onclick = () => { this.onAddMomentLoadClick() }

    document.getElementById('self-weight-checkbox').onclick = () => { this.onSelfWeightClick() }
    document.getElementById('show-all-load-cases-1').onclick = () => { this.onShowAllLoadCases1Click() }
    document.getElementById('show-all-load-cases-2').onclick = () => { this.onShowAllLoadCases2Click() }

    if (document.getElementById('show-all-load-cases-1').checked === false) {
      document.getElementById('simple-load-magnitude-table').classList.remove('d-none')
      document.getElementById('full-load-magnitude-table').classList.add('d-none')
    } else {
      document.getElementById('simple-load-magnitude-table').classList.add('d-none')
      document.getElementById('full-load-magnitude-table').classList.remove('d-none')
    }
  }
}

customElements.define('load-dialog-component', LoadDialogComponent)
